import React from'react';
import Button from'../components/ui/Button';

interface CostComparisonSectionProps {}

const CostComparisonSection = ({}: CostComparisonSectionProps) => {
  const competitors = [
    {
      name: "Bank Escrow",
      cost: "$10K-$30K + weeks setup",
      highlight: false,
      color: "bg-red-500",
    },
    {
      name: "Letter of Credit",
      cost: "$5K-$50K+ per transaction",
      highlight: false,
      color: "bg-red-500",
    },
    {
      name: "Escrow.com",
      cost: "1-3% ($10K-$30K)",
      highlight: false,
      color: "bg-yellow-500",
    },
    {
      name: "AverPact",
      cost: "~$10K (1% + gas) - instant setup",
      highlight: true,
      color: "bg-green-500",
    },
  ]

  return (
    <section className="w-full bg-[#141A23] py-12 sm:py-16 lg:py-20">
      <div className="w-full max-w-[1200px] mx-auto px-3 xs:px-4 sm:px-6 lg:px-8">
        <div className="flex flex-col items-center gap-8 sm:gap-12 w-full">
          {/* Header */}
          <div className="flex flex-col items-center gap-3 xs:gap-4 w-full max-w-[700px]">
            <Button
              text="COST EXAMPLE"
              text_font_size="14"
              text_font_family="DM Sans"
              text_font_weight="600"
              text_line_height="18px"
              text_text_align="center"
              text_text_transform="uppercase"
              fill_background="linear-gradient(180deg,#FF3333 0%, #FF3333 100%)"
              border_border_radius="6px"
              effect_box_shadow="0px 4px 16px rgba(72,28,0,0.25)"
              padding="6px 12px"
              className="w-auto text-[10px] xs:text-xs sm:text-sm text-white"
            />
            
            <h2 className="text-[24px] sm:text-[32px] md:text-[40px] font-semibold leading-snug text-center text-white font-poly">
              $1M Contract
            </h2>
          </div>

          {/* Comparison Cards */}
          <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-4 sm:gap-6 w-full">
            {competitors.map((item) => (
              <div 
                key={item.name}
                className={`flex flex-col gap-4 p-5 sm:p-6 rounded-xl border transition-all duration-300 ${
                  item.highlight 
                    ? 'bg-[#FF3333] border-[#FF3333] shadow-[0px_20px_40px_#FF000033]' 
                    : 'bg-[#1a2130] border-[#ffffff1e] hover:border-[#ffffff3f]'
                }`}
              >
                <div className="flex items-center gap-3">
                  <div className={`w-3 h-3 rounded-full ${item.color} flex-shrink-0`}></div>
                  <h3 className="text-lg sm:text-xl font-semibold font-poly text-white">
                    {item.name}
                  </h3>
                </div>
                
                <p className={`text-base sm:text-lg font-semibold font-dm ${item.highlight ? 'text-white' : 'text-[#ffffffcc]'}`}>
                  {item.cost}
                </p>
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  )
}

export default CostComparisonSection
